import { Route } from "react-router-dom";
import ProtectedRoute from "../protectedRoute";
import { COMMON_PERMISSIONS, MODULES_LIST, SUB_MODULES_LIST } from "../../../utils/helper";
import ManageSalary from "../../main/payroll/innerScreens/manageSalary/page";
import PayrollAttendance from "../../main/payroll/innerScreens/payrollAttendance/page";
import EndOfService from "../../main/payroll/innerScreens/endOfService/page";
import SalaryReport from "../../main/payroll/innerScreens/salaryReport/page";
import SalaryReportDetails from "../../main/payroll/innerScreens/salaryReport/innerScreens/page";
import Payroll from "../../main/payroll/innerScreens/mainPage/page";

// HR Module Payroll Components
import ManageAllowances from "../../main/hr/manageAllowances/page";
import ManageDeduction from "../../main/hr/manageDeduction/page";
import ManageSalaryStructure from "../../main/hr/manageSalaryStructure/page";
import EmployeeSalarySetup from "../../main/hr/employeeSalarySetup/page";
import GenerateSalary from "../../main/hr/generateSalary/page";
import PayrollReports from "../../main/hr/payrollReport/page";
import PayrollDashboard from "../../main/hr/payrollManagement/PayrollDashboard/page";
import StatutoryReports from "../../main/hr/payrollManagement/StatutoryReports/page";
import PayrollRunDetail from "../../main/hr/payrollManagement/PayrollRunDetail/page";
import PayslipViewer from "../../main/hr/payrollManagement/PayslipViewer/page";
import ManageSalaryIncrement from "../../main/hr/manageSalaryIncrement/page";

const payrollRoutes = [
  {
    path: "/payroll",
    element: <Payroll />, 
    access: null,
    module: MODULES_LIST.PAYROLL,
    subModule: null,
  },
  {
    path: "/payroll/manage-salary",
    element: <ManageSalary />, 
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.PAYROLL,
    subModule: SUB_MODULES_LIST.PAYROLL.MANAGE_SALARY,
  },
  {
    path: "/payroll/payroll-attendance",
    element: <PayrollAttendance />, 
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.PAYROLL,
    subModule: SUB_MODULES_LIST.PAYROLL.MANAGE_SALARY_REPORT,
  },
  {
    path: "/payroll/end-of-service",
    element: <EndOfService />, 
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.PAYROLL,
    subModule: SUB_MODULES_LIST.PAYROLL.MANAGE_SALARY_REPORT,
  },
  {
    path: "/payroll/salary-report",
    element: <SalaryReport />, 
    access: [COMMON_PERMISSIONS.VIEW],
    module: MODULES_LIST.PAYROLL,
    subModule: SUB_MODULES_LIST.PAYROLL.MANAGE_SALARY_REPORT,
  },
  {
    path: "/payroll/salary-report/details/:id",
    element: <SalaryReportDetails />, 
    access: [COMMON_PERMISSIONS.CREATE],
    module: MODULES_LIST.PAYROLL,
    subModule: SUB_MODULES_LIST.PAYROLL.MANAGE_SALARY_REPORT,
  },

  // ========================================
  // 💰 NEW PAYROLL MANAGEMENT ROUTES
  // ========================================
  {
    path: "/payroll/manage-allowance",
    element: <ManageAllowances />,
  },
  {
    path: "/payroll/manage-deduction",
    element: <ManageDeduction />,
  },
  {
    path: "/payroll/salary-structure",
    element: <ManageSalaryStructure />,
  },
  {
    path: "/payroll/employee-salary",
    element: <EmployeeSalarySetup />,
  },
  {
    path: "/payroll/generate-salary",
    element: <GenerateSalary />,
  },
  {
    path: "/payroll/payout-reports",
    element: <PayrollReports />,
  },
  {
    path: "/payroll/dashboard",
    element: <PayrollDashboard />,
  },
  {
    path: "/payroll/statutory-reports",
    element: <StatutoryReports />,
  },
  {
    path: "/payroll/payroll-runs/:runId",
    element: <PayrollRunDetail />,
  },
  {
    path: "/payroll/payslips/:employeeId?",
    element: <PayslipViewer />,
  },
  {
    path: "/payroll/salary-increment",
    element: <ManageSalaryIncrement />,
  },
];

export default function renderPayrollRoutes() {
  const renderRoute = (route, access = false) => {
    return (
      <Route
        key={route.path}
        path={route.path}
        element={
          access ? (
            route.element
          ) : (
            <ProtectedRoute
              module={route.module}
              submodule={route.subModule}
              access={route.access}
              path={route.path}
            >
              {route.element}
            </ProtectedRoute>
          )
        }
      />
    );
  };
  return payrollRoutes.map((route) => renderRoute(route));
}
